import { format, isValid, parseISO } from 'date-fns'

export function safeFormat(value: string | null | undefined, formatStr: string, fallback = ''): string {
  if (!value) return fallback
  const date = parseISO(value)
  return isValid(date) ? format(date, formatStr) : fallback
}
